import { createStore } from "vuex";

export default createStore({
  state: {
    activeGame: false,
    timer: {
      min: 1,
      max: 5,
      value: 2,
    },
    letters: [
      { value: "a", active: true },
      { value: "b", active: true },
      { value: "c", active: true },
      { value: "d", active: true },
      { value: "e", active: true },
      { value: "f", active: true },
      { value: "g", active: true },
      { value: "h", active: true },
      { value: "i", active: true },
      { value: "j", active: true },
      { value: "k", active: true },
      { value: "l", active: true },
      { value: "m", active: true },
      { value: "n", active: true },
      { value: "o", active: true },
      { value: "p", active: true },
      { value: "q", active: true },
      { value: "r", active: true },
      { value: "s", active: true },
      { value: "t", active: true },
      { value: "u", active: true },
      { value: "v", active: true },
      { value: "w", active: true },
      { value: "x", active: true },
      { value: "y", active: true },
      { value: "z", active: true },
    ],
  },
  mutations: {
    /**
     * Update the timer value
     * @param {Object} state vuex state
     * @param {Number} timerValue new value for the timer
     */
    updateTimer(state, timerValue) {
      state.timer.value = timerValue;
    },
    /**
     * Update a letter with the given letter id
     * @param {Object} state vuex state
     * @param {*} letter object with an id (string) and active (true|false) value
     */
    updateLetter(state, letter) {
      state.letters.forEach((item) => {
        if (item.value === letter.value) {
          item.active = letter.active;
        }
      });
    },
    /**
     *
     * @param {Object} state vuex state
     * @param {Boolean} status the new game status to be set
     */
    updateGame(state, status) {
      state.activeGame = status;
    },
  },
  getters: {
    getGameStatus(state) {
      return state.activeGame;
    },
    getTimer(state) {
      return state.timer;
    },
    getLetters(state) {
      return state.letters;
    },
    getActiveLetters(state) {
      return state.letters.filter((letter) => letter.active);
    },
  },
  actions: {
    /**
     * Call the updateTimer mutation
     * @param {Object} context vuex context
     * @param {Number} timerValue new value for the state timer
     */
    updateTimer(context, timerValue) {
      context.commit("updateTimer", timerValue);
    },
    /**
     * Call the updateLetter mutation
     * @param {Object} context vuex context
     * @param {Objext} letter object with an id (string) and active (true|false) value
     */
    updateLetter(context, letter) {
      if (letter.value !== undefined) {
        context.commit("updateLetter", letter);
      }
    },
    /**
     * Update the game status
     * @param {Object} context vuex context
     * @param {Boolean} status the new game status to be set
     */
    updateGame(context, status) {
      context.commit("updateGame", status);
    },
  },
  modules: {},
});
